import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'expandable-panel',
  imports: [MatExpansionModule],
  templateUrl: './expandable-panel.component.html',
  styleUrl: './expandable-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandablePanelComponent {}
